<p-confirmDialog></p-confirmDialog>

<ng-container>
  @if (loading) {
  <div class="skeleton-container">
    <p-skeleton width="60%" height="2rem"></p-skeleton>

    <p-skeleton width="40%" height="1.5rem" styleClass="mr-2"></p-skeleton>
    <p-skeleton width="80%" height="1.5rem"></p-skeleton>
    <p-skeleton width="60%" height="1.5rem"></p-skeleton>
    <p-skeleton width="70%" height="1.5rem"></p-skeleton>

    <p-skeleton animation="none" width="90%" height="1.5rem"></p-skeleton>
    <p-skeleton width="70%" height="1.5rem"></p-skeleton>
    <p-skeleton width="100%" height="20rem"></p-skeleton>
    <p-skeleton width="80%" height="3rem"></p-skeleton>

    <p-skeleton width="20%"></p-skeleton>
    <p-skeleton width="30%" height="3rem"></p-skeleton>
  </div>
  } @else {
    <!-- #region Kopfbereich -->

    <div class="activity-header">
      <h1>
        <app-activity-type
          [typeName]="activity.activityType.typeName"
        ></app-activity-type
        >{{ activity.activityName }}
      </h1>
      <span>ID {{ activity.activityId }}</span>
    </div>

    <!-- #endregion Kopfbereich -->

    <!-- #region UPLOAD FREITEXT-->
    @if (activity.voucher?.freitext) {
      <p-editor [formControl]="richTextControl" [readonly]="true"></p-editor>
    }

    <!-- ===================================================================== -->
    <!-- #region BERATUNG (Beratungsgespräch) -->
    @if (activity.consultation) {
      <div class="activity-details">
        <p-editor [formControl]="richTextControl" [readonly]="true"></p-editor>
        <app-attachments
          [urls]="activity.consultation.fileUrls"
        ></app-attachments>
      </div>
    }
    <!-- #endregion BERATUNG -->

    <!-- ===================================================================== -->
    <!-- #region ABWESENHEIT -->
    @if (activity.absence) {
      <dl class="activity-details">
        <dt>Abwesenheitsart</dt>
        <dd>{{ activity.absence.absenceType }}</dd>
        <dt>Startdatum:</dt>
        <dd>{{ activity.absence.startDate | date: "dd.MM.yyyy" }}</dd>
        <dt>Enddatum:</dt>
        <dd>{{ activity.absence.endDate | date: "dd.MM.yyyy" }}</dd>

        @if (activity.absence.emailContent) {
          <dt>E-Mail-Inhalt der Krankmeldung</dt>
          <dd><span [innerHTML]="activity.absence.emailContent"></span></dd>
        }

        <dd>
          <app-attachments
            [urls]="activity.absence.fileUrls"
            [showTitle]="true"
          >
          </app-attachments>
        </dd>
      </dl>
    }
    <!-- #endregion ABWESENHEIT -->

    <!-- ===================================================================== -->
    <!-- #region LERNERFOLGSKONTROLLE -->
    @if (activity.learningSuccessControl) {
      <div class="activity-details">
        <p>
          Gesamtnote:
          <strong>{{ activity.learningSuccessControl.gesamtnote }}</strong>
        </p>
        <p>
          Gesamtpunkte:
          <strong>{{ activity.learningSuccessControl.gesamtpunkte }}</strong>
        </p>
        <app-attachments
          [urls]="activity.learningSuccessControl.fileUrls"
        ></app-attachments>
      </div>
    }
    <!-- #endregion LERNERFOLGSKONTROLLE -->

    <!-- ===================================================================== -->
    <!-- #region NOTIZ -->
    @if (activity.note) {
      <div class="activity-details">
        <p-editor [formControl]="richTextControl" [readonly]="true"></p-editor>
        <p>
          Erstellt von <strong>{{ activity.updator }}</strong>
        </p>
        <app-attachments [urls]="activity.note.fileUrls"></app-attachments>
      </div>
    }
    <!-- #endregion NOTIZ -->

    <!-- ===================================================================== -->
    <!-- #region KONTAKT -->
    @if (activity.contact) {
      <div class="activity-details">
        <p>
          Datum:
          <strong>{{
            activity.contact.contactDate | date: "dd.MM.yyyy"
          }}</strong>
          um <strong>{{ activity.contact.contactTime }}</strong>
        </p>
        <p>
          Dauer: <strong>{{ activity.contact.duration }}</strong>
        </p>
        <p-editor
          [formControl]="richTextControl"
          [readonly]="true"
          placeholder=""
        ></p-editor>
        <app-attachments [urls]="activity.contact.fileUrls"></app-attachments>
      </div>
    }
    <!-- #endregion KONTAKT -->

    <!-- ===================================================================== -->
    <!-- #region EMAIL -->
    @if (activity.email) {
      <div class="activity-details">
        <p><strong>Betreff: </strong>{{ activity.email.subject }}</p>
        <p><strong>Sender: </strong>{{ activity.email.sender }}</p>
        <p><strong>Empfänger: </strong>{{ activity.email.recipient }}</p>
        <p>
          <strong>Interessent/Teilnehmer:in: </strong
          >{{ activity.email.participant }}
        </p>
        <p>
          <strong>Gesendet: </strong
          >{{ activity.email.sentAt | date: "dd.MM.yyyy HH:mm  " }}
        </p>
        <p-editor [formControl]="richTextControl" [readonly]="true"></p-editor>

        <app-attachments
          [urls]="
            activity.email.fileUrls?.length
              ? activity.email.fileUrls
              : activity.email.fileUrl
                ? [activity.email.fileUrl]
                : []
          "
          [showTitle]="true"
        >
        </app-attachments>
      </div>
    }
    <!-- #endregion EMAIL -->

    <!-- ===================================================================== -->
    <!-- #region Teilnehmerfeedback -->
    @if (activity?.feedback) {
      <div class="activity-details">
        <app-feedback-form
          [existingFeedbackId]="activity.feedback.id"
          mode="show"
        />
      </div>
    }

    <!-- #endregion Teilnehmerfeedback -->

    <!-- ===================================================================== -->
    <!-- #region Allgemeine Details -->
    <dl class="activity-details">
      @if (activity.courseNames && activity.courseNames.length) {
        <dt>Betroffene Kurse</dt>
        @for (courseName of activity.courseNames; track $index) {
          <dd>
            {{ courseName }}
          </dd>
        }
      }
      @if (activity.users && activity.users.length) {
        <dt>Betroffene Nutzer</dt>
        @for (user of activity.users; track $index) {
          <dd>
            {{ user.fullName }}
          </dd>
        }
      }

      <dt>Verantwortlich</dt>
      <dd>{{ activity.inCharge }}</dd>
      <dt>Erstellt</dt>
      <dd>{{ activity.createdAt | date: "dd.MM.yyyy HH:mm" }}</dd>
      @if (activity.updatedAt) {
        <dt>Zuletzt Aktualisiert</dt>
        <dd>
          {{ activity.updatedAt | date: "dd.MM.yyyy HH:mm" }} von
          {{ activity.updator }}
        </dd>
      }
    </dl>
    <!-- #endregion Allgemeine Details -->

    <!-- ===================================================================== -->
    <!-- #region IHK-Bildungsgutschein -->
    @if (activity.voucher?.fileUrl) {
      <app-attachments
        [urls]="[activity.voucher.fileUrl]"
        [showTitle]="true"
      >
      </app-attachments>
    }

    <!-- #endregion IHK-Bildungsgutschein -->

    <!-- ===================================================================== -->
    <!-- #region EIGNUNGSTEST -->
    @if (activity.eignungstest) {
      <div class="activity-details">
        <p><strong>Eignungstest Details</strong></p>
        <p>
          Test Datum:
          <strong>{{
            activity.eignungstest.testDate | date: "dd.MM.yyyy"
          }}</strong>
        </p>

        <app-attachments
          [urls]="
            activity.eignungstest.pdfUrl ? [activity.eignungstest.pdfUrl] : []
          "
          [showTitle]="true"
        >
        </app-attachments>

        @if (activity.eignungstest.emailText) {
          <p>
            <strong>E-Mail Text:</strong><br />
            <span [innerHTML]="activity.eignungstest.emailText"></span>
          </p>
        }
      </div>
    }
    <!-- #endregion EIGNUNGSTEST -->

    <!-- ===================================================================== -->
    <!-- #region Buttons -->
    <div class="form-buttons">
      @if (activity?.feedback) {
        <button
          pButton
          label="Feedback bearbeiten"
          title="Feedback bearbeiten"
          icon="pi pi-pencil"
          (click)="routeToFeedback(activity.feedback.id)"
          class="p-button-success"
        ></button>
      }

      <button
        pButton
        type="button"
        label="Löschen"
        icon="pi pi-trash"
        [raised]="true"
        severity="danger"
        title="Aktivität löschen"
        (click)="confirmDelete($event)"
      ></button>

      <!-- Editieren ist fehlerbehaftet! Also nicht auf Prod! -->
      <!-- Ausnahme: Abwesenheiten sind bewusst auch in Prod bearbeitbar (siehe canEditActivity) -->
      @if (canEditActivity) {
        <button
          pButton
          label=""
          title="Aktivität aktualisieren"
          icon="pi pi-pencil"
          (click)="updateActivity()"
          class="p-button-success"
        ></button>
      }

      <button
        pButton
        type="button"
        label="Abbrechen"
        title="Dialog verlassen"
        icon="pi pi-times"
        class="p-button-secondary"
        (click)="closeDialog()"
      ></button>
    </div>
    <!-- #endregion Buttons -->
  }
</ng-container>
